import { cn } from "~/lib/utils";
import LandingContent from "./content";
import arrowRightWhiteImg from "~/assets/landing-page/arrow-right-white.svg";
import { useRef, useEffect } from "react";

const GOODS_URLS = {
  goodsImg1: "https://asset.blidz.com/blidz-cdn/web/landing-page/goods-image-1.png",
  goodsImg2: "https://asset.blidz.com/blidz-cdn/web/landing-page/goods-image-2.png",
  goodsImg3: "https://asset.blidz.com/blidz-cdn/web/landing-page/goods-image-3.png",
  goodsImg4: "https://asset.blidz.com/blidz-cdn/web/landing-page/goods-image-4-v2.png",
  goodsImg5: "https://asset.blidz.com/blidz-cdn/web/landing-page/goods-image-5.png",
};

export default function LandingFeed({ onGoToShop }: { onGoToShop: (tab?: string) => void }) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const handleWheel = (e: WheelEvent) => {
      e.preventDefault();
      scrollContainer.scrollBy({
        left: e.deltaY + e.deltaX,
      });
    };

    scrollContainer.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      scrollContainer.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <LandingContent className="my-[24px] flex flex-col items-center justify-center gap-[32px]">
      <div className="justify-center p-[24px] text-center text-4xl leading-10 font-semibold text-wrap md:text-nowrap">
        <span className="bg-gradient-to-tr from-[#A4E97E] via-[#99D0E5] via-40% to-[#FFADBB] bg-clip-text text-transparent">
          4M+ exclusive deals for you
        </span>
      </div>
      <div
        ref={scrollContainerRef}
        className={cn(
          "scrollbar-hide overflow-x-auto",
          "flex flex-nowrap justify-start gap-[24px]",
          "w-[321px] md:w-[450px] lg:w-[1024px] xl:w-[1440px]"
        )}
      >
        <img
          src={GOODS_URLS.goodsImg1}
          onClick={() => onGoToShop("hot_sale")}
          className={cn(
            "cursor-pointer hover:shadow-lg active:scale-95",
            "h-[313px] w-[210px] md:h-[438px] md:w-[294px]"
          )}
        />
        <img
          src={GOODS_URLS.goodsImg2}
          onClick={() => onGoToShop("home_garden")}
          className={cn(
            "cursor-pointer hover:shadow-lg active:scale-95",
            "h-[313px] w-[210px] md:h-[438px] md:w-[294px]"
          )}
        />
        <img
          src={GOODS_URLS.goodsImg3}
          onClick={() => onGoToShop("branded")}
          className={cn(
            "cursor-pointer hover:shadow-lg active:scale-95",
            "h-[313px] w-[210px] md:h-[438px] md:w-[294px]"
          )}
        />
        <img
          src={GOODS_URLS.goodsImg4}
          onClick={() => onGoToShop("grocery")}
          className={cn(
            "cursor-pointer hover:shadow-lg active:scale-95",
            "h-[313px] w-[210px] md:h-[438px] md:w-[294px]"
          )}
        />
        <img
          src={GOODS_URLS.goodsImg5}
          onClick={() => onGoToShop("health_beauty")}
          className={cn(
            "cursor-pointer hover:shadow-lg active:scale-95",
            "h-[313px] w-[210px] md:h-[438px] md:w-[294px]"
          )}
        />
      </div>
      <button
        onClick={() => onGoToShop()}
        className="inline-flex h-12 cursor-pointer items-center justify-center gap-1 rounded-2xl bg-gradient-to-b from-zinc-800 to-black px-5 py-2 outline-1 outline-offset-[-1px] outline-white/5 hover:shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
      >
        <div className="justify-start text-base leading-normal font-bold text-white">Go Shopping</div>
        <img src={arrowRightWhiteImg} alt="arrow-right" className="h-4 w-4" />
      </button>
    </LandingContent>
  );
}
